import React from "react";
import { useTranslation } from "react-i18next";

interface MonthToDateTotals {
  total_subtotal_sales: number;
  total_tips: number;
  total_tax: number;
  total_paid_orders: number;
  total_refunded_orders: number;
  total_service_fee_charge: number;
  total_rewards: number;
  total_price: number;
  total_refunded_amount: number;
}

interface Props {
  monthToDateTotals: MonthToDateTotals | null;
  loading: boolean;
}

const MonthToDateSummary: React.FC<Props> = ({
  monthToDateTotals,
  loading,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-8 rounded-lg bg-white p-4 shadow">
      <h2 className="mb-4 text-xl font-bold">
        {t("back.management.report.monthToDate")}
      </h2>
      {loading ? (
        <div className="flex h-32 items-center justify-center">
          <div className="spinner" />
        </div>
      ) : (
        <div className="mt-4 grid grid-cols-2 gap-3">
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.subtotal")}
            </p>
            <p className="text-lg font-bold">
              $
              {monthToDateTotals?.total_subtotal_sales
                ? parseFloat(monthToDateTotals.total_subtotal_sales.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.reward")}
            </p>
            <p className="text-lg font-bold">
              -$
              {monthToDateTotals?.total_rewards
                ? parseFloat(monthToDateTotals.total_rewards.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.tip")}
            </p>
            <p className="text-lg font-bold">
              $
              {monthToDateTotals?.total_tips
                ? parseFloat(monthToDateTotals.total_tips.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.tax")}
            </p>
            <p className="text-lg font-bold">
              $
              {monthToDateTotals?.total_tax
                ? parseFloat(monthToDateTotals.total_tax.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.paidOrder")}
            </p>
            <p className="text-lg font-bold">
              {monthToDateTotals?.total_paid_orders
                ? monthToDateTotals.total_paid_orders
                : "0"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.refundedAmount")}
            </p>
            <p className="text-lg font-bold">
              -$
              {monthToDateTotals?.total_refunded_amount
                ? parseFloat(monthToDateTotals.total_refunded_amount.toFixed(2))
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.serviceFee")}
            </p>
            <p className="text-lg font-bold">
              $
              {monthToDateTotals?.total_service_fee_charge
                ? parseFloat(
                    monthToDateTotals.total_service_fee_charge.toFixed(2),
                  )
                : "0.00"}
            </p>
          </div>
          <div>
            <p className="mt-2 text-lg font-semibold">
              {t("back.management.report.total")}
            </p>
            <p className="text-lg font-bold">
              $
              {monthToDateTotals?.total_price
                ? parseFloat(monthToDateTotals.total_price.toFixed(2))
                : "0.00"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthToDateSummary;
